export default __webpack_public_path__ + "static/media/assets.abd3df2f.svg";